import { Injectable } from '@angular/core';
import * as localForage from 'localforage';
import { Observable, catchError, from, tap, throwError } from 'rxjs';

export interface IndexedDbConfig {
    name: string,
    storeName: string,
}

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {

    setLocalStorageData(key: string, data: any): any {
        if (key && data) {
            localStorage.setItem(key, JSON.stringify(data));
            return true;
        } else {
            return false;
        }
    }

    getLocalStorageData(key: string): string {
        if (key) {
            if (localStorage.getItem(key)) {
                const data = localStorage.getItem(key) || '';
                return data;
            } else {
                return;
            }
        } else {
            return;
        }
    }

    removeLocalStorageData(key: string): boolean {
        if (key) {
            if (localStorage.getItem(key)) {
                localStorage.removeItem(key);
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    removeAllLocalStorage(): boolean {
        try {
            localStorage.clear();
            return true;
        } catch (error) {
            return false;
        }
    }

    setItemIndexedDB(config: IndexedDbConfig, key: string, value: any): Observable<any> {
        const store = localForage.createInstance({ name: config.name, storeName: config.storeName });
        return from(store.setItem(key, value)).pipe(
            tap((response) => {
                return response;
            }),
            catchError(error => {
                console.error(error);
                return throwError(() => new Error(error));
            })
        );
    }

    getItemIndexedDB(config: IndexedDbConfig, key: string): Observable<any> {
        const store = localForage.createInstance({ name: config.name, storeName: config.storeName });
        return from(store.getItem(key)).pipe(
            tap((response) => {
                return response;
            }),
            catchError(error => {
                console.error(error);
                return throwError(() => new Error(error));
            })
        );
    }

    removeKeyIndexedDB(config: IndexedDbConfig, key: string): Observable<void> {
        const store = localForage.createInstance({ name: config.name, storeName: config.storeName });
        return from(store.removeItem(key)).pipe(
            tap((response) => {
                return response;
            }),
            catchError(error => {
                console.error(error);
                return throwError(() => new Error(error));
            })
        );
    }

    deleteInstanceDB(instanceName: string): Observable<void> {
        return from(localForage.dropInstance({ name: instanceName })).pipe(
            tap((response) => {
                return response;
            }),
            catchError(error => {
                console.error(error);
                return throwError(() => new Error(error));
            })
        );
    }

    deleteInstanceTable(config: IndexedDbConfig): Observable<void> {
        return from(localForage.dropInstance({ name: config.name, storeName: config.storeName })).pipe(
            tap((response) => {
                return response;
            }),
            catchError(error => {
                console.error(error);
                return throwError(() => new Error(error));
            })
        );
    }

    clearIndexedDB(): Observable<void> {
        return from(localForage.clear()).pipe(
            catchError((error) => {
                console.error('Error clearing IndexedDB database:', error);
                return throwError(() => new Error(error));
            })
        );
    }
}